import { createReducer } from "@reduxjs/toolkit";
import { TYPES } from "../../common/constants";
import moment from 'moment';

const fetchInboxListDone = (state, {payload}) => {
    return {
        ...state, inboxList: payload, inboxListLoader: false
    }
}
const saveMessageInLocalList = (state, {payload}) => {
   let updatedData = state.inboxList.map(x => {
       if(x.referenceId === payload.referenceId) {
           const params = 
            { ...x, 
                id: payload.id,
                message: payload.message,
                sentOn: payload.sentOn,
                sentBy: payload.sentBy,
                sentByName:payload.sentByName,
                sentByImage:payload.sentByImage,
                sentTo:payload.sentTo,
                sentToName:payload.sentToName,
                sentToImage:payload.sentToImage,
                status:payload.status,
                fileName: payload.fileName,
                fileURL: payload.fileURL,
                messageOrigin:payload.messageOrigin,
                receivedOn: payload.receivedOn,
                isRead: payload.isRead === "true" ? true : payload.isRead === "false" ? false : payload.isRead
            };
            return params;
       } else {
           return x;
       }
    })
    return {
        ...state, inboxList: updatedData, 
    }
}
const fetchChatMessagesDone = (state, {payload}) => {
    return {
        ...state, chatMessagesList: payload, inboxListLoader: false
    }
}
const fetchInboxAnnouncementsListDone = (state, {payload}) => {
    return {
        ...state, inboxAnnouncementsList: payload, inboxListLoader: false
    } 
}
const fetchChatUserInformationDone = (state, {payload}) => {
    return {
        ...state, chatUserInformation: payload, inboxListLoader: false
    }
}
const fetchInboxAnnouncementsByPropertyDone = (state, {payload}) => {
    return {
        ...state, announcmentsListByProperty: payload, inboxListLoader: false
    }
}
const fetchInboxSuitesListDone = (state, {payload}) => {
    return {
        ...state, inboxSuitesList: payload, inboxListLoader: false
    }
}
const fetchInboxServiceRequestListDone = (state, {payload}) => {
    return {
        ...state, inboxServiceRequestsList: [...state.inboxServiceRequestsList, ...payload], inboxListLoader: false
    }
}
const fetchInboxServiceRequestListSearchDone = (state, {payload}) => {
    return {
        ...state, inboxServiceRequestsList: [...payload], inboxListLoader: false
    }
}
const clearInboxServiceRequestsList = (state) => {
    return {
        ...state, inboxServiceRequestsList: [], pageCount: 0, paginationCount: 0
    }
}
const saveInboxItem = (state, {payload}) => {
    return {
        ...state, inboxList: [payload, ...state.inboxList], inboxListLoader: false
    }
}
const saveSelectedItem = (state, {payload}) => {
    return {
        ...state, inboxSelectedItem: payload
    }
}
const saveSendMessageToChatList = (state, {payload}) => {
    let msgObj;
    let filterData = state.chatMessagesList.filter(cm => cm.date === moment().format('MM/DD/YYYY'));
    if(filterData && filterData.length > 0) {
        msgObj = [{...filterData[0], messages: [...filterData[0].messages, payload]}]
        let updatedArray =   state.chatMessagesList.map(obj => msgObj.find(o => o.date === obj.date) || obj);
        return {
            ...state, chatMessagesList: updatedArray
        }
    } else {
        msgObj = {date: moment().format('MM/DD/YYYY'), messages: [payload]}
        return {
            ...state, chatMessagesList: [...state.chatMessagesList, msgObj]
        }
    }
}
const startInboxLoader = (state) => {
    return {
        ...state, inboxListLoader: true
    }
}
const stopInboxLoader = (state) => {
    return {
        ...state, inboxListLoader: false
    }
}
const setAnnoucement = (state, {payload}) => {    
    return {
        ...state, announcement: payload
    }
}
const clearInboxAnnouncementsByProperty = (state) => {
    return {
        ...state, announcmentsListByProperty: []
    };
}
const clearChatMessages = (state) => {
    return {
        ...state, chatMessagesList: []
    };
}
const clearInboxListDone = () => {
    return initialState;
}
const clearChatUserInformationDone = (state) => {
    return {
        ...state, chatUserInformation: {}
    }
}
const saveInboxPaginationCount = (state, {payload}) => {
    return {
        ...state, paginationCount: payload
    } 
}
const saveInboxPageCount = (state, {payload}) => {
    return {
        ...state, pageCount : payload
    } 
}
const clearInboxPaginationCount = (state) => {
    return {
        ...state, paginationCount : 0, pageCount: 0
    } 
  }
 
  /* 
    Created By: Sai Prasad
    Created Date: 14/09/2022
    Jira Ticket: JUN-3083
    Description: function to update unread message to read status in redux state
*/
const updateMessageToUnreadToRead = (state, {payload}) => {
    let updatedData = state.inboxList.map(x => {
        if(x.referenceId === payload.referenceId) {
             return { ...x, isRead: true}
        } else {
            return x;
        }
     })
     return {
         ...state, inboxList: updatedData, 
     }
}

const initialState = {
    inboxList: [],
    chatMessagesList: [],
    inboxAnnouncementsList: [],
    chatUserInformation: {},
    inboxListLoader: false,
    announcmentsListByProperty: [],
    announcement: {},
    inboxSuitesList: [],
    inboxServiceRequestsList: [],
    pageCount: 0,
    paginationCount: 0,
    inboxSelectedItem: {}
}

export default createReducer(initialState, {
    [TYPES.FETCH_INBOX_LIST_DONE] : fetchInboxListDone,
    [TYPES.CLEAR_INBOX_LIST_DONE] : clearInboxListDone,
    [TYPES.FETCH_CHAT_MESSAGES_DONE]: fetchChatMessagesDone,
    [TYPES.FETCH_INBOX_ANNOUNCEMENTS_LIST_DONE]: fetchInboxAnnouncementsListDone,
    [TYPES.CLEAR_INBOX_CHAT_MESSAGES_DONE]: clearChatMessages,
    [TYPES.START_INBOX_LOADER]: startInboxLoader,
    [TYPES.FETCH_CHAT_USER_INFORMATION_DONE]: fetchChatUserInformationDone,
    [TYPES.STOP_INBOX_LOADER]: stopInboxLoader,
    [TYPES.FETCH_INBOX_ANNOUNCEMENTS_DONE]: fetchInboxAnnouncementsByPropertyDone,
    [TYPES.SET_ANNOUNCEMENT]: setAnnoucement,
    [TYPES.CLEAR_INBOX_ANNOUNCEMENTS_BY_PROPERTY]: clearInboxAnnouncementsByProperty,
    [TYPES.FETCH_INBOX_SUITES_LIST_DONE]: fetchInboxSuitesListDone,
    [TYPES.SAVE_INBOX_ITEM]: saveInboxItem,
    [TYPES.CLEAR_CHAT_USER_INFORMATION_DONE]: clearChatUserInformationDone,
    [TYPES.FETCH_INBOX_SERVICE_REQUESTS_LIST_DONE]: fetchInboxServiceRequestListDone,
    [TYPES.SAVE_MESSAGE_IN_LOCAL_LIST]: saveMessageInLocalList,
    [TYPES.INBOX_SERVICE_REQUEST_PAGINATION]: saveInboxPaginationCount,
    [TYPES.INBOX_SERVICE_REQUEST_PAGE_COUNT]: saveInboxPageCount,
    [TYPES.CLEAR_INBOX_PAGINATION_COUNT]: clearInboxPaginationCount,
    [TYPES.FETCH_INBOX_SERVICE_REQUESTS_LIST_SEARCH_DONE]: fetchInboxServiceRequestListSearchDone,
    [TYPES.CLEAR_INBOX_SERVICE_REQUESTS]: clearInboxServiceRequestsList,
    [TYPES.SAVE_SELECTED_ITEM_DONE]: saveSelectedItem,
    [TYPES.SAVE_SEND_MESSAGE_TO_CHAT_LIST]: saveSendMessageToChatList,
    [TYPES.UPDATE_MESSAGE_TO_INREAD_TO_READ]:updateMessageToUnreadToRead
})